
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-password",
      function () {
        return require("private-next-pages/create-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-password"])
      });
    }
  